export interface IIdRowId {
    id: string;
    rowId: string;
}

export class IdRowId implements IIdRowId {
    id: string;
    rowId: string;

    constructor();
    constructor(obj: IIdRowId);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.rowId = obj && obj.rowId || "";
    }
}